/* DSL Free-shipping progress — render in cart drawer / cart page */
(function(){
  var THRESHOLD = (window.DSL_CONFIG && window.DSL_CONFIG.freeShippingThreshold) || 9900; // cents
  function render(cart){
    document.querySelectorAll("[data-shipping-progress]").forEach(function(el){
      var remain = Math.max(0, THRESHOLD - cart.total_price);
      var pct = Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100));
      el.innerHTML = remain === 0
        ? "<strong>✓ Je verzending is gratis!</strong>"
        : "Nog €" + (remain/100).toFixed(2).replace(".", ",") + " tot gratis verzending<div class=\"dsl-progress\"><span style=\"width:" + pct + "%\"></span></div>";
    });
  }
  function refresh(){ fetch("/cart.js").then(function(r){return r.json();}).then(render).catch(function(){}); }
  document.addEventListener("DOMContentLoaded", refresh);
  document.addEventListener("dsl:cart:change", refresh);
})();